<template>
	<router-link :to="to" class="btn">
		<span class="inner"><slot></slot></span>
		<icon v-if="icon" :icon="icon"></icon>
	</router-link>
</template>

<script>
	export default {
		props: ['icon', 'to']
	}
</script>